import Vue from 'vue'
import VueI18n from 'vue-i18n'

import ar from 'vuetify/lib/locale/ar'
import en from 'vuetify/lib/locale/en'
import es from 'vuetify/lib/locale/es'

Vue.use(VueI18n)

const messages = {
  es: {
    ...require('@/locales/es.json'),
    $vuetify: es,
  },
  en: {
    ...require('@/locales/en.json'),
    $vuetify: en,
  },
  ar: {
    ...require('@/locales/ar.json'),
    $vuetify: ar,
  },
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'es',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'es',
  messages,
})
